module.exports = __webpack_public_path__ + "static/media/whatsapp.0fc87cfc.svg";